import { IndexPage } from '../page-components/index-page';

export default IndexPage;
